
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/categories",
      function () {
        return require("private-next-pages/default/desktop/categories.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/default/desktop/categories"])
      });
    }
  